import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getAllEmployeeAuth } from "../../../actions/employeeAuthAction";
import Rendertable from "./Rendertable";

const List = ({ getAllEmployeeAuth, updatelist, setUpdatelist }) => {
    useEffect(() => {
        getAllEmployeeAuth();
        setUpdatelist(true);
    }, [updatelist, getAllEmployeeAuth, setUpdatelist]);

    return (
        <div style={{ clear: "both" }}>
            <Rendertable setUpdatelist={setUpdatelist} />
        </div>
    );
};

export default connect(null, { getAllEmployeeAuth })(List);
